import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Theme } from '@radix-ui/themes'
import { RouterProvider } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { AuthenticationProvider } from './contexts/AuthenticationContext.tsx'
import { router } from './router.tsx'
import { DebugPanel } from './components/DebugPanel.tsx'
import '@radix-ui/themes/styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

export const Application = () => {
  const isDevelopment = import.meta.env.DEV

  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <AuthenticationProvider>
        <QueryClientProvider client={queryClient}>
          <Theme>
            <RouterProvider router={router} />
            {isDevelopment && <DebugPanel />}
          </Theme>
        </QueryClientProvider>
      </AuthenticationProvider>
    </GoogleOAuthProvider>
  )
}